module.exports = __webpack_public_path__ + "static/media/valor4.6be3dcfc.png";